import React from 'react';
import { Button } from '@edgebox/react-components';

export function ScreenHeader({ title, onBack, right }: { title: string; onBack?: () => void; right?: React.ReactNode }) {
  return (
    <div className="d-flex justify-content-between align-items-center mb-3">
      <h2 className="mb-0">{title}</h2>
      <div className="d-flex gap-2">
        {right}
        {onBack ? (
          <Button variant="light" onClick={onBack}>
            Back
          </Button>
        ) : null}
      </div>
    </div>
  );
}
